<div>
  <app-report-schedule-form [reportLayout]="layout" (scheduleChanged)="scheduleChanged($event)">
  </app-report-schedule-form>
</div>
